import _ from "lodash";
// import{ useScreenLoader }from 'src/components/CommonComponents/ScreenLoader';
import {
  API_CONSTANTS,
  APP_KEY_BLOWFISH2,
  DUMMY_OB_NO,
  ERROR,
  SPOUSE_COVER,
  SUCCESS,
} from "@ipru-common/constants/SiteConstants";
import { useGlobalContext } from "@ipru-common/context/GlobalContext";
import useBlowFish from "@ipru-common/hooks/useBlowFish";
import useService from "@ipru-common/hooks/useService";
import { ApiName, MIDDLEWARE } from "@ipru-common/services/ApiEndpoints";
import { ACCESS_TOKEN_SOURCE_ID, fetchAccessToken } from "@ipru-common/services/service";
import useDropOffDataMapping from "./useDropOffDataMapping";
import { readQueryParams, unsetCookie } from "@ipru-common/utils/CommonFunctions";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { useEffect } from "react";
import appConfig from "@ipru-common/config/environment";
import ENV from "@ipru-common/config/environment/constant";

let dropOffAttemp = 1;
let tokenAttempt = 1;
const useSpouseAppApi = () => {
  // const { startLoader, stopLoader } = useScreenLoader();
  const { encryptBlowfish } = useBlowFish({ key: APP_KEY_BLOWFISH2 });
  const { mapDropOffDataWithSpouse } = useDropOffDataMapping();
  const { callService } = useService();

  const {
    global: {
      SPOUSE_COVER: { calculatorFormData, appFormData },
    },
    setGlobal,
  } = useGlobalContext();

  const { global: globalObject } = useGlobalContext();

  const updateAppFormContext = (data) => {
    setGlobal((prevGlobal) => ({
      ...prevGlobal,
      [SPOUSE_COVER]: {
        ...prevGlobal?.[SPOUSE_COVER],
        appFormData: {
          ...prevGlobal?.[SPOUSE_COVER]?.appFormData,
          ...data,
        },
      },
    }));
  };

  useEffect(() => {
    const queryParams = readQueryParams();
    if (
      globalObject?.[SPOUSE_COVER]?.appFormData?.generatedAppNumber &&
      globalObject?.appFormData?.generatedAppNumber &&
      !queryParams.get("applicationState")
    ) {
      setGlobal((prevGlobal) => ({
        ...prevGlobal,
        callDropOff: Date.now(),
      }));
    }
  }, [globalObject?.[SPOUSE_COVER]?.appFormData?.generatedAppNumber, globalObject?.appFormData?.generatedAppNumber]);

  const generateApplicationNumber = () => {
    // Initially set dummy app number
    let appNO = appFormData?.appNO || DUMMY_OB_NO;
    updateAppFormContext({ appNO, generatingAppNumber: !appFormData?.appNO ? true : false });

    dropOff({
      callBack: !appFormData?.generatedAppNumber
        ? (response) => {
            if (response?.transactionId) {
              dropOff(
                {
                  callBack: () => {
                    getBolAppNumber(response);
                  },
                },
                response?.transactionId || false
              );
            }
          }
        : null,
    });
  };

  const dropOff = (funcProps = {}, transactionId = false) => {
    if (!_.isEmpty(calculatorFormData, true)) {
      const tokenName = "SPOUSE_ACCESS_TOKEN";
      fetchAccessToken({
        mobile:
          calculatorFormData?.nri === OPTION_VALUES.NRI_YES && calculatorFormData?.country_code != 91
            ? calculatorFormData?.country_code?.toString() + calculatorFormData.mobileno
            : calculatorFormData.mobileno,
        dob: calculatorFormData?.user_dob.replaceAll("/", ""),
        tokenName,
      })
        .then((token) => {
          let dropOffData = {};

          dropOffData = mapDropOffDataWithSpouse({ data: globalObject, appName: SPOUSE_COVER });

          if (transactionId) {
            dropOffData = { ...dropOffData, transactionId };
          }
          const data = {
            paramListMap: JSON.stringify(dropOffData),
          };

          dropOffApi({ token, data })
            .then((response) => {
              let { status, result } = response;

              if (result?.error && !result?.status) {
                result.status = ERROR;
              }

              if (status === SUCCESS && result?.status !== ERROR) {
                if (funcProps?.callBack) {
                  funcProps?.callBack({ transactionId: result.transactionId });
                }
              } else if (
                (result?.response?.data?.error === "invalid_token" ||
                  result?.response?.status === 401 ||
                  result?.status === ERROR) &&
                dropOffAttemp <= 3
              ) {
                dropOffAttemp++;
                unsetCookie(tokenName);
                dropOff(funcProps);
              } else {
                dropOffAttemp = 1;
                updateAppFormContext({
                  generatingAppNumber: false,
                });
              }
            })
            .catch(() => {
              if (funcProps?.callBack) {
                // disable generatingAppNumber flag and run queued drop offs
                updateAppFormContext({
                  generatingAppNumber: false,
                });
              }
            });
        })
        .catch(() => {
          if (tokenAttempt <= 3) {
            setTimeout(() => {
              tokenAttempt++;
              unsetCookie(tokenName);
              dropOff(funcProps);
            }, 5000);
          } else {
            tokenAttempt = 1;
            updateAppFormContext({
              generatingAppNumber: false,
            });
          }
          console.log("access token api failed");
        });
    }
  };

  const dropOffApi = (apiProps) => {
    const { appName: ipruAppName, reqType, reqSubType } = API_CONSTANTS;

    return callService({
      params: {
        apiName: ApiName.DROPOFF,
        method: "POST",
        headers: {
          Authorization: `Bearer ${apiProps?.token}`,
          "x-api-key": ENV().REACT_APP_XAK,
        },
        data: {
          source: ACCESS_TOKEN_SOURCE_ID,
          appName: ipruAppName,
          reqType,
          reqSubType,
          ...apiProps?.data,
          Authorization: `Bearer ${apiProps?.token}`,
        },
      },
      loader: apiProps?.loader ? true : false,
    });
  };

  const getBolAppNumber = async (funcProps) => {
    const config = await appConfig();
    const middlewareType = config.API.APP_NUMBER_GENERATION.MIDDLEWARE;
    const method = middlewareType === MIDDLEWARE ? "POST" : "GET";
    const { transactionId = "" } = funcProps;
    const { source, sourceKey } = API_CONSTANTS;

    const encData = window.btoa(
      encryptBlowfish(
        JSON.stringify({
          source,
          sourceKey,
          QNTransactionId: transactionId,
          ...(calculatorFormData?.nri === OPTION_VALUES.NRI_YES && calculatorFormData?.country_code != "91"
            ? {
                mobileNo: calculatorFormData?.country_code?.toString() + calculatorFormData?.mobileno,
                isNRI: "Y",
              }
            : {
                mobileNo: calculatorFormData?.mobileno,
              }),
          dob: calculatorFormData?.user_dob.replaceAll("/", "-"),
          isSolution: "N",
        })
      )
    );
    callService({
      params: {
        apiName: ApiName.APP_NUMBER_GENERATION,
        method,
        ...(method === "POST"
          ? {
              data: {
                bolData: encData,
              },
            }
          : {
              queryParams: {
                bolData: encData,
              },
            }),
      },
      loader: false,
    })
      .then((response) => {
        const { result } = response;
        updateAppFormContext({
          appNO: result?.appNo || DUMMY_OB_NO,
          generatedAppNumber: result?.appNo || "",
          generatingAppNumber: false,
          transactionId,
        });

        setGlobal((prevGlobal) => ({
          ...prevGlobal,
          callDropOff: Date.now(),
        }));
      })
      .catch(() => {
        updateAppFormContext({
          appNO: DUMMY_OB_NO,
          generatingAppNumber: false,
          transactionId,
        });

        setGlobal((prevGlobal) => ({
          ...prevGlobal,
          callDropOff: Date.now(),
        }));
      });
  };

  return { generateApplicationNumber, getBolAppNumber, dropOffApi, dropOff };
};

export default useSpouseAppApi;
